import type {QuestionModelV3, GuessModelV1, DraftGuessModelV1} from '@albert-io/models';
import type {Mutate, StoreApi} from 'zustand';
import makeConstants from 'lib/makeConstants';

export enum SaveStatus {
  DEFAULT,
  LOADING,
  LOAD_ERROR,
  SAVED,
  SAVE_ERROR,
  SAVING
}

// FOR ZUSTAND STORE usage

export const allSaveStatuses = [
  'default',
  'loading',
  'loadError',
  'saved',
  'saveError',
  'saving'
] as const;

export const saveStatus = makeConstants(...allSaveStatuses);

export namespace QuestionType {
  export type SaveStatus = (typeof allSaveStatuses)[number];
  export interface CoreState {
    // Question data
    question: QuestionModelV3 | null;
    questionId: string | null;
    correctAnswer: Record<string, string> | null;
    // Draft guess state
    draftGuess: DraftGuessModelV1 | null;
    lastSaveTime: number | null;
    // Guess info
    guess: GuessModelV1 | null;
    isSubmitted: boolean;
  }

  export interface CoreActions {
    addQuestionInfo: (question: QuestionModelV3) => void;
    addDraftGuessInfo: (draftGuess: DraftGuessModelV1) => void;
    addGuessInfo: (guess: GuessModelV1) => void;
    // Draft guess actions
    buildGuessContent: () => Record<string, string>;
  }
}

export type CoreQuestionStore = QuestionType.CoreState & QuestionType.CoreActions;

// Derived from zustand's own middleware-mutated setState (devtools + immer),
// rather than hand-rolled — zustand 5 narrowed the `replace: true` overload to
// require the full state, which a hand-written signature cannot express.
export type SetStateWithImmer<T> = Mutate<
  StoreApi<T>,
  [['zustand/devtools', never], ['zustand/immer', never]]
>['setState'];
